// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__xyLRb","list":"BalanceDue_list__2cKO1","listRow":"BalanceDue_listRow__3mjGo","total":"BalanceDue_total__-ft3o"};